import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const API_BASE = process.env.REACT_APP_API_URL || "https://go.brandhives.com";
const AgencyCtx = createContext(null);

function authHeaders() {
  const st = localStorage.getItem("nectar_st");
  return { "Content-Type": "application/json", "X-Session-Token": st };
}

export function AgencyProvider({ children }) {
  const [agency, setAgency] = useState(null);
  const [stats, setStats] = useState(null);
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const r = await fetch(`${API_BASE}/app/api/agency/dashboard`, { headers: authHeaders() });
      if (r.ok) {
        const d = await r.json();
        setAgency(d.agency);
        setStats(d.stats);
        setClients(d.clients || []);
      } else if (r.status === 403) {
        setError("not_agency");
      } else {
        setError("Failed to load agency dashboard");
      }
    } catch {
      setError("Network error");
    }
    setLoading(false);
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <AgencyCtx.Provider value={{ agency, stats, clients, loading, error, refresh }}>
      {children}
    </AgencyCtx.Provider>
  );
}

export function useAgency() {
  return useContext(AgencyCtx);
}

export { API_BASE, authHeaders };
